import { useState } from 'react';
import { Badge } from './badges';
import { CheckIcon } from '../common';
import type { MatchPairsFixture } from '../../../mock/practice';

/** UI nối cặp chạy trên fixture (DB có 0 bản ghi MATCH_PAIRS) — xem src/mock/practice.ts. */
export function MatchPairsExercise({ data }: { data: MatchPairsFixture }) {
  const [selectedLeft, setSelectedLeft] = useState<string | null>(null);
  const [matched, setMatched] = useState<string[]>([]);
  const [wrong, setWrong] = useState<string | null>(null);

  const pressLeft = (id: string) => {
    if (matched.includes(id)) return;
    setWrong(null);
    setSelectedLeft(selectedLeft === id ? null : id);
  };

  const pressRight = (id: string) => {
    if (!selectedLeft || matched.includes(id)) return;
    if (id === selectedLeft) {
      setMatched([...matched, id]);
      setSelectedLeft(null);
      setWrong(null);
    } else {
      setWrong(id);
      setSelectedLeft(null);
    }
  };

  const done = matched.length === data.pairs.length;

  const cell = (content: React.ReactNode, border: string, bg: string, onClick: () => void, isMatched: boolean, jp: boolean) => (
    <button
      onClick={onClick}
      style={{
        border: `2px solid ${border}`,
        background: bg,
        borderRadius: 'var(--radius-card)',
        padding: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        cursor: 'pointer',
        fontFamily: jp ? 'var(--font-jp)' : 'var(--font-vi)',
        fontSize: 16,
        color: 'var(--ink)',
        textAlign: 'left',
      }}
    >
      {content}
      {isMatched && <CheckIcon c="var(--success)" size={14} />}
    </button>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Badge tone="warning">Dữ liệu mẫu</Badge>
        <Badge tone="info">Nối cặp</Badge>
      </div>
      <div style={{ fontSize: 12.5, color: 'var(--text-secondary)' }}>Chọn 1 từ bên trái rồi chọn nghĩa bên phải</div>
      {done && (
        <div style={{ alignSelf: 'flex-start', background: 'var(--success)', color: '#fff', borderRadius: 999, padding: '8px 16px', fontSize: 13, fontWeight: 600 }}>
          Nối xong hết rồi!
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {data.pairs.map((pair) => {
            const isMatched = matched.includes(pair.id);
            const isSelected = selectedLeft === pair.id;
            const border = isMatched ? 'var(--success)' : isSelected ? 'var(--cta-default)' : 'var(--border-default)';
            const bg = isMatched ? 'rgba(46,139,87,0.12)' : 'var(--surface-page)';
            return <div key={pair.id}>{cell(<span>{pair.jp}</span>, border, bg, () => pressLeft(pair.id), isMatched, true)}</div>;
          })}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {data.rightOrder.map((id) => {
            const pair = data.pairs.find((p) => p.id === id)!;
            const isMatched = matched.includes(id);
            const isWrong = wrong === id;
            const border = isMatched ? 'var(--success)' : isWrong ? 'var(--error)' : 'var(--border-default)';
            const bg = isMatched ? 'rgba(46,139,87,0.12)' : isWrong ? 'var(--error-bg)' : 'var(--surface-page)';
            return <div key={id}>{cell(<span>{pair.vi}</span>, border, bg, () => pressRight(id), isMatched, false)}</div>;
          })}
        </div>
      </div>
    </div>
  );
}
